module.exports = __webpack_public_path__ + "img/sld_ch_11_t1_green.3dc91ee9.svg";